import { Avatar, Flex } from 'antd';
import chatBotIcon from 'assets/chat-bot-icon.svg';
import './ModelBubble.css';

type AllProps = {
  text?: string;
};

function ModelBubbleLoading({ text = '' }: AllProps) {
  return (
    <div className="model-bubble-container">
      <Flex align="start" gap={10}>
        <div>
          <Avatar size={40} src={chatBotIcon} className="avatar" shape="circle" />
        </div>
        <div className="model-bubble">
          <div className="typing">
            {text}
            <span className="typing-dots"></span>
          </div>
        </div>
      </Flex>
    </div>
  );
}

export default ModelBubbleLoading;
